<template>
  <div>
    <div v-for="(action, index) in value" :key="index">
      <div v-if="index > 0" class="d-flex justify-content-center w-100">
        <div style="width: 1px; height: 16px;" class="bg-secondary my-2">&nbsp;</div>
      </div>
      <ActionForm :community-id="communityId" :actions="actions" :data-types="dataTypes" :value="action" :trigger="trigger" @update:value="updateActions(item => item[index] = $event)" :errors="errors && errors[index] && typeof errors[index] === 'object' ? errors[index] : undefined" @delete="updateActions(item => item.splice(index, 1))"/>
    </div>
    <div class="text-primary border-primary mt-4" style="border-style: dashed; border-width: 2px; border-radius: 1em" :class="{ clickable: trigger, 'opacity-5': !trigger, 'border-danger text-danger': errors && (!value || value.length === 0) }" @click="trigger ? adding = true : undefined">
      <div class="text-center p-3">
        <i class="fas fa-plus" style="font-size: 1.6em"></i>
      </div>
    </div>
    <ModalView v-model:active="adding">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("please_select") }}</h3>
          <ModalCloseButtonView @click="adding = false"/>
        </div>
      </template>
      <template v-slot:body>
        <ActionSelectionView :trigger="trigger" :actions="actions" @selected="updateActions(item => item.push({ key: $event, parameters: {} })); adding = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script>
import ActionForm from "@/systems/modules/automation/form/actions/ActionForm.vue";
import {ModalView, ModalCloseButtonView} from "@niftybit/vue";
import ActionSelectionView from "@/systems/modules/automation/form/actions/ActionSelectionView.vue";

export default {
  name: "ActionsForm",
  components: {ActionSelectionView, ActionForm, ModalView, ModalCloseButtonView},
  props: {
    communityId: String,
    trigger: Object,
    dataTypes: Array,
    value: Array,
    actions: Array,
    errors: Object
  },
  emits: ["update:value"],
  methods: {
    updateActions(callback) {
      let item = JSON.parse(JSON.stringify(this.value ?? []));
      callback(item);
      this.$emit("update:value", item);
    },
  },
  data() {
    return {
      adding: false
    }
  }
}
</script>

<style scoped>

</style>